// src/views/Settings.js
import React from 'react';

const Settings = () => {
  return <div>Settings Page</div>;
};

export default Settings;